import React from "react";
import { Card, CardHeader, CardBody, Progress } from "reactstrap";

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const RiskScoreCard = () => {
  return (
    <Card style={{...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light d-flex align-items-center" >
        
        <div style={pageIconWrapStyle} className="me-2"><i
            className="ri-shield-check-line "
            style={pageIconStyle}
          ></i></div>
        <h5 className="card-title mb-0">
          TOTAL OT RISK SCORE
        </h5>
      </CardHeader>

      <CardBody>

        <div className="text-center mb-4">
          <div
            style={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              border: "4px solid #ef4444",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "auto",
              fontSize: 26,
              fontWeight: "600",
              color: "#ef4444",
            }}
          >
            78
          </div>
        </div>

        <div className="mb-3">
          <small className="text-muted">Vulnerability Severity</small>
          <Progress value={82} color="danger" style={{ height: "6px" }} />
        </div>

        <div className="mb-3">
          <small className="text-muted">Exploitable ICS CVEs</small>
          <Progress value={65} color="warning" style={{ height: "6px" }} />
        </div>

        <div className="mb-3">
          <small className="text-muted">Protocol Anomalies</small>
          <Progress value={45} color="info" style={{ height: "6px" }} />
        </div>

        <div>
          <small className="text-muted">Malware Indicators</small>
          <Progress value={22} color="success" style={{ height: "6px" }} />
        </div>

      </CardBody>
    </Card>
  );
};

export default RiskScoreCard;